import React, { Component } from "react";

//import best_c_logo from '../../images/BEST Courses Logo.png';
import best_c_logo from '../../images/logo_v2.png';

class HomeNav extends Component {
    render() {
        return(
            <>
            <header id="section_header" class="navbar-fixed-top main-nav" role="banner">
                <div class="container">
                    <div class="navbar-header ">
                        <button type="button" class="navbar-toggle" data-toggle="collapse"
                                data-target="#bs-example-navbar-collapse-1">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <a class="navbar-brand" href="">
                           <img src={best_c_logo} alt="EMEC logo" class="img-responsive" style={{height:'200%'}}></img>
        </a>
                    </div>
                    <nav class="collapse navbar-collapse navigation" id="bs-example-navbar-collapse-1" role="navigation">
                        <ul class="nav navbar-nav navbar-right ">
                            <li><a href="/#home" class="page-scroll">HOME</a></li>
                            <li><a href="/#course" class="page-scroll">COURSE</a></li>
                            <li><a href="/#ct" class="page-scroll">CORE TEAM</a></li>
                            <li><a href="/#materials" class="page-scroll">MATERIALS</a></li>
                            <li><a href="/#lecture" class="page-scroll">LECTURERS</a></li>
                            <li><a href="/#partners" class="page-scroll">PARTNERS</a></li>
                            {/*<li class="dropdown">
                                <a href="/#application" class="page-scroll dropdown-toggle">Přihláška</a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                  <a class="dropdown-item disabled" href="/application-cs-single">Case Study jednotlivec</a>
                                  <a class="dropdown-item disabled" href="/application-td-single">Team Design jednotlivec</a>
                                  <a class="dropdown-item disabled" href="/application-cs-team">Case Study tým</a>
                                  <a class="dropdown-item disabled" href="/application-td-team">Team Design tým</a>
                                </div>
        </li>*/}
                        </ul>
                    </nav>
                </div>
            </header>
            </>
        );
    }
}

export default HomeNav;